import * as React from "react";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { LocationDescriptor } from "history";
import { resolvePathWithSpaceId } from "components/Navigation/resolvePathWithSpaceId";

interface LinkProps extends RouteComponentProps<{ spaceId: string }> {
    to: LocationDescriptor;
}

class SwitcherLink extends React.Component<LinkProps> {
    render() {
        const { staticContext, to, ...rest } = this.props;
        // tslint:disable-next-line:jsx-ban-elements
        return <Link {...rest} to={resolvePathWithSpaceId(to, this.props.match.params.spaceId)}>{this.props.children}</Link>;
    }
}

export default withRouter(SwitcherLink);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navbar/SwitcherLink.tsx